
import { FC } from "react";
import { Controller } from "react-hook-form";
import { CurrentAndPriorTreatmentProps } from "../currentAndPriorTreatment/types";
import DateField from "../dateField";

const FEV1_OPTION =
  "FEV1 spirometry testing has been completed prior to initiation of therapy";

const conditions = [
  "Diabetes controlled on Afrezza medication and with no adverse effects",
  FEV1_OPTION,
  "Type 1 diabetes patient will also receive basal insulin via injection or pump",
  "Contraindications to Afrezza have been ruled out",
  "Type 2 diabetes patient will also receive basal insulin via injection or pump",
  "Patient is a non-smoker or has recently stopped smoking",
];

const PatientConditions: FC<CurrentAndPriorTreatmentProps> = ({
  control,
  watch,
  setValue,
}): JSX.Element => {
  return (
    <div className="row mt-4">
      <h5>Select all that apply to the Patient</h5>

      <div className="col-md-12">
        <Controller
          name="prescription_information_attributes.applicable_to_patient"
          control={control}
          defaultValue={[]}
          render={({ field }) => {
            const selected: string[] = (field.value || []).filter(Boolean);

            const toggle = (value: string, checked: boolean) => {
              let updated = [...selected];

              if (checked) {
                if (!updated.includes(value)) {
                  updated.push(value);
                }
              } else {
                updated = updated.filter((v) => v !== value);

                if (value === FEV1_OPTION) {
                  setValue(
                    "prescription_information_attributes.last_fev1_date",
                    ""
                  );
                }
              }

              field.onChange(updated);
            };

            return (
              <>
                {conditions.map((item) => (
                  <div className="form-check" key={item}>
                    <label className="form-check-label col-12">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={selected.includes(item)}
                        onChange={(e) => toggle(item, e.target.checked)}
                      />
                      {item}
                    </label>

                    {item === FEV1_OPTION && selected.includes(FEV1_OPTION) && (
                      <div className="ms-4 mt-2 col-md-6">
                        <DateField
                          control={control}
                          name="prescription_information_attributes.last_fev1_date"
                          label="Date of Last FEV1"
                        />
                      </div>
                    )}
                  </div>
                ))}
              </>
            );
          }}
        />
      </div>
    </div>
  );
};

export default PatientConditions;